module.exports = __webpack_public_path__ + "img/Logo_Blanc_Fond Transparent.2f581146.png";